<template>
  <div style="padding: 0 24px">
    <div>简单捡品统计</div>
    <StatementForm source="Simplelnspection"></StatementForm>
    <exportBtn></exportBtn>
    <WmsTable :is-pagination="false" :columns="columns"> </WmsTable>
  </div>
</template>

<script>
import StatementForm from "@/views/statement/components/form";
import exportBtn from "@/views/statement/components/exportBtn";
import WmsTable from "@/components/WmsTable";

import { SimpleInspectionColums } from "@/views/statement/SimpleInspectionColumsData";
export default {
  components: { StatementForm, exportBtn, WmsTable },
  props: {},
  data() {
    return {
      columns: SimpleInspectionColums,
    };
  },

  created() {},

  methods: {},
};
</script>

<style scoped lang="less"></style>
